import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers';
const Icon = React.forwardRef(function Icon({ size = 14, alt, color, className, onClick }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsxs("svg", { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 24 24', fill: fillColor, className: className, children: [_jsx("path", { d: 'M24 24H0V0h24v24z', fill: 'none' }), _jsx("circle", { cx: '12', cy: '12', r: '8' })] }));
});
export default React.memo(Icon);
